import React from 'react';
import { App as AntdApp, ConfigProvider, theme as antdTheme } from 'antd';

export default function AppTheme({ children, mode = 'light' }) {
  const isDark = mode === 'dark';

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#325d88',
          colorLink: '#1f5f99',
          colorBgLayout: '#f5f7fa',
          colorBgBase: '#ffffff',
          colorBgContainer: '#ffffff',
          colorBorder: '#dbe3ec',
          colorText: '#1f2d3d',
          colorTextSecondary: '#4f6072',
          fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
          fontSize: 16,
          lineHeight: 1.6,
          borderRadius: 10,
          borderRadiusLG: 12,
          controlHeight: 38,
          controlHeightLG: 42,
        },
        components: {
          Button: {
            fontWeight: 600,
            controlHeight: 38,
            borderRadius: 8,
          },
          Layout: {
            bodyBg: '#f5f7fa',
            headerBg: '#325d88',
            siderBg: '#ffffff',
          },
          Card: {
            borderRadiusLG: 12,
            colorBorderSecondary: '#dbe3ec',
            headerFontSize: 16,
          },
          Typography: {
            titleMarginBottom: 12,
            titleMarginTop: 0,
          },
          Table: {
            headerBg: '#eef3f8',
            headerColor: '#1f2d3d',
            borderColor: '#dbe3ec',
          },
          Descriptions: {
            labelBg: '#eef3f8',
          },
          Input: {
            controlHeight: 38,
          },
          Select: {
            controlHeight: 38,
          },
          InputNumber: {
            controlHeight: 38,
          },
        },
      }}
    >
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
